import { Facebook } from './Facebook';
import { Habr } from './Habr';
import { Telegram } from './Telegram';
import { Vkontakte } from './Vkontakte';
import { Youtube } from './Youtube';

export { Facebook, Habr, Telegram, Vkontakte, Youtube };
